import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ScrollView, Text, View } from 'react-native';
import { ActivityIndicator, Button, Hr, ModalHeader } from 'LocalGluons';
import { t } from 'Locale';
import { useStore } from 'Store';
import { useAppEntryContext } from 'Pages/AppEntry';
import { CommonActions, useNavigation } from '@react-navigation/native';
import defaultStyles from './Logout.jss';
import { Device } from 'DeviceUtils';
import { useNavigationPropsContext } from '../../Navigation/navigationPropsContext';

const LogoutPage = () => {
    const [loading, setLoading] = useState(false);
    const { appManager, setUserData, userData } = useStore();
    const { initialize } = useAppEntryContext();
    const { navigate } = useNavigationPropsContext();
    const navigation = useNavigation();

    useEffect(() => {
        if (!userData) {
            navigation.dispatch(
                CommonActions.reset({
                    index: 0,
                    routes: [
                        {
                            name: 'Main', state: {
                                routes: [{ name: 'watch-tv' }],
                            }
                        },
                    ],
                })
            );
        }
    }, [userData]);

    const closeModal = () => {
        if (navigation.canGoBack()) {
            navigation.goBack();
        } else {
            navigate('Main', { screen: 'watch-tv' });
        }
    };

    const onLogoutPressed = async () => {
        setLoading(true);
        try {
            await appManager.wipeCache();
            await appManager.logout();
            setUserData(null);
            await initialize();
        } catch (error) {
            // setError({ error, screenId: 'logout' });

            setLoading(false);
            console.log('Logout error', error);
        }
    };

    return (
        <View style={defaultStyles.container}>
            <ModalHeader onPress={closeModal} />
            <ScrollView contentContainerStyle={[defaultStyles.scrollViewContainer]}>
                <View style={defaultStyles.innerContainer}>
                    <View style={defaultStyles.titleContainer}>
                        <Text style={defaultStyles.title}>
                            {t('COMMON.LOGOUT_PROMPT_SHORT_MSG')}
                        </Text>
                    </View>
                    <Hr />
                    <Text style={defaultStyles.question}>{t('COMMON.LOGOUT_PROMPT_LONG_MSG')}</Text>
                    <View style={defaultStyles.buttonsContainer}>
                        <Button
                            testID="logout_button"
                            style={{
                                button: defaultStyles.containerItem
                            }}
                            title={t('COMMON.LOGOUT')}
                            onPress={onLogoutPressed}
                        />
                        <Button
                            testID="cancel_button"
                            style={{
                                button: defaultStyles.containerItem
                            }}
                            isSecondary
                            title={t('COMMON.BTN_CANCEL')}
                            onPress={closeModal}
                        />
                    </View>
                </View>
            </ScrollView>
            {loading && <ActivityIndicator isOverlay modal />}
        </View>
    );
};

LogoutPage.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};

export default LogoutPage;
